export const AssetEN = {
    "asset": "Asset",
    "handover": "Asset Handover",
    "invoke": "Asset Invoke",
    "depreciation": "Asset Depreciation",
    "store" : "Asset Store",
    "general" : "General settings",
    "position" : "Property location",
    "unit" : "Unit",
    "type" : "Property type",
    "properties" : "Properties",
    "supplier" : "Supplier"

}